<template>
  <div class="gmail-callback-container">
    <div class="callback-content">
      <div v-if="loading" class="loading-state">
        <div class="spinner"></div>
        <h2>Processing Gmail Authentication...</h2>
        <p>Please wait while we complete your authentication.</p>
      </div>
      
      <div v-else-if="success" class="success-state">
        <div class="success-icon">✅</div>
        <h2>Gmail Authentication Successful!</h2>
        <p>You can now send emails through Gmail. This window will close automatically.</p>
      </div>
      
      <div v-else class="error-state">
        <div class="error-icon">❌</div>
        <h2>Gmail Authentication Failed</h2>
        <p>{{ errorMessage }}</p>
        <button @click="closeWindow" class="retry-btn">Close Window</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GmailCallback',
  data() {
    return {
      loading: true,
      success: false,
      errorMessage: ''
    };
  },
  
  mounted() {
    this.handleCallback();
  },
  
  methods: {
    handleCallback() {
      const urlParams = new URLSearchParams(window.location.search);
      const success = urlParams.get('success');
      const error = urlParams.get('error');
      
      setTimeout(() => {
        this.loading = false;
        
        if (success === 'true') {
          this.success = true;
          // Auto-close window after 3 seconds
          setTimeout(() => {
            this.closeWindow();
          }, 3000);
        } else {
          this.success = false;
          this.errorMessage = this.getErrorMessage(error);
        }
      }, 1500); // Show loading for at least 1.5 seconds
    },
    
    getErrorMessage(errorCode) {
      switch (errorCode) {
        case 'no_code':
          return 'No authorization code received from Google.';
        case 'auth_failed':
          return 'Authentication failed. Please try again.';
        default:
          return 'An unknown error occurred during authentication.';
      }
    },
    
    closeWindow() {
      // Try to close the popup window
      if (window.opener) {
        window.close();
      } else {
        // If not in popup, redirect to main app
        this.$router.push('/');
      }
    }
  }
};
</script>

<style scoped>
.gmail-callback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  font-family: 'Inter', sans-serif;
}

.callback-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 90%;
}

.loading-state, .success-state, .error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4285f4;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.success-icon, .error-icon {
  font-size: 3rem;
  margin-bottom: 0.5rem;
}

h2 {
  color: #333;
  margin: 0;
  font-size: 1.5rem;
}

p {
  color: #666;
  margin: 0;
  line-height: 1.5;
}

.retry-btn {
  background: #4285f4;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 1rem;
  transition: background-color 0.2s;
}

.retry-btn:hover {
  background: #3367d6;
}
</style>
